"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = index;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _react = _interopRequireDefault(require("react"));
// import Pdf from '@mikecousins/react-pdf';
// eslint-disable-next-line @typescript-eslint/no-require-imports
// const { DownloadIcon } = require('@tencent/ixd-icons-react/dist');
function index(props) {
  var title = props.title,
    style = props.style;
  // const [page, setPage] = useState(1); // pdf当前页数
  // // const [loading, setLoading] = useState(true); // 是否加载中
  // const [scale, setScale] = useState(1.2); // pdf当前缩放倍数
  // const [pageTotal, setPageTotal] = useState(0); // pdf总页数
  // const pdfRef = useRef() as any;
  // const handleSrc = decodeURIComponent(src);
  // const fileName = handleSrc?.split('/')?.pop(); // 由url获取文件名
  // const onDocumentComplete = (pages: any) => {
  //   setPageTotal(pages);
  //   // setLoading(false);
  // };
  // const handleScale = (isScale: boolean) => {
  //   if (isScale) {
  //     const newScale = Math.round((scale + 0.1) * 10) / 10;
  //     setScale(newScale);
  //   } else {
  //     const newScale = Math.round((scale - 0.1) * 10) / 10;
  //     setScale(newScale);
  //   }
  // };
  // const handleScroll = (e: any) => {
  //   const scrollTop = e.target?.scrollTop;
  //   const pdfview = pdfRef?.current;
  //   const listNodes = pdfview?.childNodes;
  //   const hCanvas = (listNodes[0] as HTMLDivElement).getBoundingClientRect().height;
  //   const heightCanvas = hCanvas + 24;
  //   const canvasLength = listNodes?.length - 1;
  //   const newPage = Math.floor(scrollTop / heightCanvas) + 2;
  //   if (newPage >= canvasLength && canvasLength !== 0) {
  //     setPage(canvasLength);
  //     return;
  //   }
  //   if (scrollTop === 0) {
  //     setPage(1);
  //   } else {
  //     setPage(newPage);
  //   }
  // };
  // useEffect(() => {
  //   const pdfview = pdfRef?.current;
  //   pdfview?.addEventListener('scroll', handleScroll);
  //   return () => {
  //     pdfview?.removeEventListener('scroll', handleScroll);
  //   };
  // }, []);
  // function fileLinkToStreamDownload(url: any, fileName: any, type: any) {
  //   // const reg = /^([hH][tT]{2}[pP]:\/\/|[hH][tT]{2}[pP][sS]:\/\/)(([A-Za-z0-9-~]+).)+([A-Za-z0-9-~\/])+$/;
  //   // if (!reg.test(url)) {
  //   //   throw new Error('传入参数不合法,不是标准的文件链接');
  //   // } else {
  //   // }
  //   let name = '';
  //   const fileArr = fileName?.split('_');
  //   if (fileArr?.length === 2 && fileArr[0]?.length === 7) {
  //     // eslint-disable-next-line prefer-destructuring
  //     name = fileArr[1];
  //   } else if (fileArr?.length > 2 && fileArr[0]?.length === 7) {
  //     fileArr?.splice(0, 1);
  //     name = fileArr?.join('_');
  //   } else {
  //     name = fileName;
  //   }
  //   const xhr = new XMLHttpRequest();
  //   xhr.open('get', url, true);
  //   xhr.setRequestHeader('Content-Type', `application/${type}`);
  //   xhr.responseType = 'blob';
  //   xhr.onload = function () {
  //     if (this.status === 200) {
  //       // 接受二进制文件流
  //       const blob = this.response;
  //       downloadExportFile(blob, name);
  //     }
  //   };
  //   xhr.send();
  // }
  // function downloadExportFile(blob: any, tagFileName: any) {
  //   const downloadElement = document.createElement('a');
  //   let href = blob;
  //   if (typeof blob === 'string') {
  //     downloadElement.target = '_blank';
  //   } else {
  //     href = window.URL.createObjectURL(blob); // 创建下载的链接
  //   }
  //   downloadElement.href = href;
  //   downloadElement.download = `${tagFileName}`; // 下载后文名
  //   document.body.appendChild(downloadElement);
  //   downloadElement.click(); // 点击下载
  //   document.body.removeChild(downloadElement); // 下载完成移除元素
  //   if (typeof blob !== 'string') {
  //     window.URL.revokeObjectURL(href); // 释放掉blob对象
  //   }
  // }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: 'pdf-view-wrap',
    style: (0, _typeof2["default"])(style) === 'object' ? style : {}
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'pdf-view-main'
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'pdf-view-title'
  }, title)));
}